import React, { useMemo, useState } from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import GoogleSignInBtn from "@/components/google/google-sign-in";
import { facebookAppId } from "@/config/app";
import {
  CHECKOUT_ID,
  DRAFT_STORAGE_KEY,
  IS_AUTH_FROM_CHECKOUT,
  SIGNUP_API_CODE_NAMES,
  SOCIAL_SIGNUP_MODES
} from "@/constants";
import { useTranslation } from "react-i18next";
import AppleSignInBtn from "@/components/apple/apple-sign-in";
import FacebookImageSrc from "@/images/icons/facebook_circle.svg";
import AuthAnaltyicsEvent from "@/services/analytics/main/authentication";
import CommonAnalyticsEvent from "@/services/analytics/main/common";
import {
  resetAuthData,
  resetTokenGeneratorCheckoutGuest,
  saveResponseUpdateDetailsData,
  setPrevPath
} from "@/redux/actions/authConfig.action";
import { useAppDispatch } from "@/redux/store";
import {
  authenticateUser,
  resetAPIError
} from "@/redux/actions/homepage.action";
import { useCountryShort, useLanguage, useRouteSlug } from "@/hooks";
import { changeCheckoutData } from "@/redux/actions/checkout.action";
import { setCountryListData } from "@/redux/actions/common.action";
import { DynamicYieldEventService } from "@/services";
import { useHistory } from "react-router-dom";
import { clearAuthEmail } from "@/util/auth";
import { saveToSessionStorage } from "@/util/storage";
import { normalizePathFromQuery } from "@/utils";

const SocialSection = () => {
  const { t } = useTranslation("auth");
  const [loader, setLoader] = useState(false);
  const dispatch = useAppDispatch();
  const routeSlug = useRouteSlug();
  const countrySlug = useCountryShort();
  const language = useLanguage();
  const history = useHistory();

  const onAuthMissingFieldsError = (response, registrationRequired) => {
    dispatch(saveResponseUpdateDetailsData(response));
    if (response.code === SIGNUP_API_CODE_NAMES.MISSING_FIELDS_REQUIRED) {
      history.push(`/${routeSlug}/login/`);
    } else {
      history.push(`/${routeSlug}/sign-up/`);
    }

    AuthAnaltyicsEvent.authenticationMethod({
      isLogin: response.code === SIGNUP_API_CODE_NAMES.MISSING_FIELDS_REQUIRED,
      method: SOCIAL_SIGNUP_MODES.APPLE
    });
  };

  const redirectParam = useMemo(() => {
    const sp = new URLSearchParams(location.search);
    const raw = sp.get("redirect") || "";
    return normalizePathFromQuery(raw);
  }, [location.search]);

  const redirection = useMemo(() => {
    const redirectionTail = location.search.split("?")[1];
    return `/${routeSlug}/${redirectParam || redirectionTail || ""}`;
  }, [redirectParam, routeSlug, location.search]);

  const isCartRedirect = useMemo(() => {
    const p = redirectParam.replace(/\/+$/, "");
    return p === "my-cart";
  }, [redirectParam]);

  const onAuthCallback = response => {
    if (response?.data?.userProfile?.customerId) {
      dispatch(resetTokenGeneratorCheckoutGuest());

      dispatch(changeCheckoutData("continueAsGuest", false));
      dispatch(changeCheckoutData("step1Completed", true));
      DynamicYieldEventService.login(response?.data?.userProfile?.email);
      if (localStorage.getItem(IS_AUTH_FROM_CHECKOUT)) {
        dispatch(setCountryListData([]));
        history.push(
          `/${routeSlug}/checkout/${localStorage.getItem(CHECKOUT_ID)}/`
        );
        localStorage.removeItem(IS_AUTH_FROM_CHECKOUT);
        return;
      }
      dispatch(resetAPIError());
    }
    if (response?.data?.userProfile?.customerId && redirection) {
      history.push(redirection);
    }
  };

  const socialCallback = async (loginFrom: string, token: string) => {
    setLoader(true);
    dispatch(resetAuthData());
    CommonAnalyticsEvent.socialClick({
      socialPlatform: loginFrom
    });
    dispatch(setPrevPath(""));
    clearAuthEmail();

    await dispatch(
      authenticateUser({
        bodyData: {
          mode: loginFrom,
          [`${loginFrom}Token`]: token
        },
        history,
        language,
        redirect: false,
        country: countrySlug,
        onAuth: onAuthCallback,
        withCartRedirect: isCartRedirect,
        onAuthMissingFieldsError
      })
    );
    setLoader(false);
  };

  const appleCallback = async response => {
    const { authorization, user } = response;
    const redirectUrl = `/${routeSlug}/sign-up/`;
    clearAuthEmail();
    dispatch(resetAuthData());
    if (authorization?.id_token) {
      setLoader(true);

      if (user) {
        const draftData = {
          formikValues: { fullname: user?.name?.firstName }
        };

        saveToSessionStorage(DRAFT_STORAGE_KEY, draftData);
      }

      await dispatch(
        authenticateUser({
          bodyData: {
            mode: SOCIAL_SIGNUP_MODES.APPLE,
            appleToken: authorization.id_token,
            firstname: user?.name?.firstName || "signUp"
          },
          history,
          language,
          redirect: false,
          country: countrySlug,
          onAuth: onAuthCallback,
          withCartRedirect: isCartRedirect,
          onAuthMissingFieldsError
        })
      );
      setLoader(false);
    } else {
      history.push(redirectUrl);
    }
  };

  return (
    <div className="authSocialSection">
      <GoogleSignInBtn
        socialCallback={socialCallback}
        className="authSocial google"
      />
      <AppleSignInBtn
        socialCallback={appleCallback}
        className="authSocial apple"
      />
      {/* <FacebookLogin
        appId={facebookAppId}
        fields="name,email,picture"
        callback={response => {
          const userProfile = response.profileObj || response;
          if (userProfile) {
            const draftData = {
              formikValues: { fullname: userProfile?.name }
            };

            saveToSessionStorage(DRAFT_STORAGE_KEY, draftData);
          }
          socialCallback(SOCIAL_SIGNUP_MODES.FACEBOOK, response);
        }}
        disableMobileRedirect={true}
        render={renderProps => (
          <button onClick={renderProps.onClick} className="authSocial facebook">
            <img src={FacebookImageSrc} alt="facebook" />
          </button>
        )}
      /> */}
    </div>
  );
};

export default SocialSection;
